// extracted by mini-css-extract-plugin
module.exports = {"containerNewEditor":"EditorContainer_containerNewEditor__1cRkd","transformComponent":"EditorContainer_transformComponent__1sZry"};